import React from 'react';
import t from '~t';
import links from '~config/links';

import { Layout, ButtonRow, Button, Alert } from '~ui';

//Free-plan gate — creating bookmarks is a Pro feature (POST /v1/raindrop[s]
//is requirePro server-side; OPEN_PRO keeps it open while billing is
//sandbox). Rendered in place of Form only on create surfaces (`new` prop);
//editing an existing bookmark never hits this. Deal submission stays
//free — it lives outside this component, in the DealCTA panel above.
export default function EditBookmarkGate() {
  return (
    <Layout data-stretch>
      <Alert>{t.s('saveBookmarksProOnly')}</Alert>

      <ButtonRow>
        <Button variant='primary' href={links.pro.buy} target='_blank'>
          {t.s('upgradeToPro')}
        </Button>
      </ButtonRow>
    </Layout>
  );
}
